import {
  PLAYER_MODALS_Z_INDEX_DECREASE,
  PLAYER_MODALS_Z_INDEX_INCREASE,
} from '../optionButtons/constants';
import {
  PLAYER_EPG_TRANSACTIONS_SHOW_EPG_TRANSACTIONS,
  PLAYER_EPG_TRANSACTIONS_HIDE_EPG_TRANSACTIONS,
} from './constants';

export const showEpgTransactions = data => dispatch => {
  dispatch({
    type: PLAYER_MODALS_Z_INDEX_INCREASE,
  });
  dispatch({
    type: PLAYER_EPG_TRANSACTIONS_SHOW_EPG_TRANSACTIONS,
    payload: data,
  });
};

export const hideEpgTransactions = (cb = () => {}) => (dispatch, getState) => {
  const state = getState();
  if (state.Player.EpgTransactions.epgTransactions.isOpen) {
    dispatch({
      type: PLAYER_MODALS_Z_INDEX_DECREASE,
    });
    dispatch({
      type: PLAYER_EPG_TRANSACTIONS_HIDE_EPG_TRANSACTIONS,
    });
  }
  cb && cb();
};
